<template>
    <div class="comp-media-pop" v-if="visible" ref="mediaPop">
        <div v-show="!showPop" class="comp-media-pop_outer">
            <div class="comp-media-pop_header">
                <div class="wrap">
                    <i class="iconfont icon-close-light" @click="close"></i>
                    <div class="operator">
                        <i
                            v-if="!sold"
                            @click="onFavoriteClick"
                            class="iconfont"
                            :class="[
                                hasFavor && !!user
                                    ? 'icon-heart-fill active'
                                    : 'icon-heart'
                            ]"
                        ></i>
                        <i
                            class="iconfont icon-big-normal-share"
                            @click="handleShare"
                        ></i>
                    </div>
                </div>
            </div>
            <div class="comp-media-pop_content">
                <template v-for="(item, index) in source.imgs" :key="index">
                    <img-box
                        v-if="['img'].includes(item.type)"
                        :src="item.preview"
                        :lazy="true"
                        alt
                        @click="streamToInner(item, index)"
                    ></img-box>
                    <div
                        v-else
                        class="video-preview"
                        @click="streamToInner(item, index)"
                    >
                        <site-img :src="item.preview"></site-img>
                        <div class="play-icon">
                            <i class="iconfont icon-arrow_04_down"></i>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="com-media-pop_inner" v-if="showPop">
            <!-- tab -->
            <div class="inner-tab">
                <template v-for="(item, index) in tabs">
                    <p
                        v-if="showCurrentTab(item)"
                        :key="'tab-' + item.name"
                        :class="{ active: selectedTabIndex === index }"
                        @click="tabClick(item, index)"
                    >
                        {{ item.name }}
                    </p>
                </template>
            </div>
            <!-- status -->
            <div class="inner-status" @click="closeInnerPop">
                <i class="iconfont icon-close-light"></i>
                <p v-show="selectedTabIndex === 0">
                    {{
                        $t('md-detail-info.of', {
                            index: imgIndex + 1,
                            length: allImgs.length
                        })
                    }}
                </p>
                <i
                    v-if="!sold"
                    @click.stop="onFavoriteClick"
                    class="iconfont"
                    :class="[
                        hasFavor && !!user
                            ? 'icon-heart-fill active'
                            : 'icon-heart'
                    ]"
                ></i>
            </div>
            <!-- content -->
            <div class="inner-content">
                <template v-for="(tab, index) in tabs">
                    <Swiper
                        :key="index"
                        v-if="selectedTabIndex === index && showCurrentTab(tab)"
                        @slideChange="slideChange"
                        @afterInit="onSwiperInit"
                    >
                        <Slide
                            v-for="(item, index) in (tab.value === 'imgs' &&
                                allImgs) ||
                                source[tab.value]"
                            :key="index"
                        >
                            <site-img
                                v-if="item.type === 'img'"
                                :src="item.preview"
                                dir="width"
                                ref="siteImg"
                            ></site-img>
                            <div
                                v-else-if="
                                    ['3d', 'virtualTour', 'video'].includes(
                                        item.type
                                    )
                                "
                                class="video-content"
                            >
                                <video
                                    v-if="canPlayWithVideo(item.url)"
                                    :src="item.url"
                                    controls="controls"
                                ></video>
                                <iframe
                                    v-else
                                    :style="iframeStyle"
                                    frameborder="no"
                                    :src="formatUrl(item.url)"
                                    rel="nofollow"
                                ></iframe></div
                            ></Slide>
                    </Swiper>
                </template>
            </div>
        </div>
        <template v-if="!showPop">
            <BottomMenu
                v-if="!sold"
                :theme="theme"
                :isOffer="isOffer"
                :scroll="false"
            />
            <!-- <RequestButton v-else  :theme="theme" /> -->
        </template>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { useUserStore, usePageStore } from '@/store';
import util from '@/common/util';
import BottomMenu from './bottom-menu.vue';
import { Swiper, SwiperSlide } from '@/common/swiper';
import API from './api.js';

function getMatterPort(links = [], type = '3d') {
    let reg = /matterport\.(com|cn)\/show/;
    let matterPortLink = links.find(l => reg.test(l));
    if (!matterPortLink) {
        return false; 
    }
    return {
        type,
        url: matterPortLink,
        preview:
            '//cdn.chime.me/image/fs/sitebuild/site-cms/listing-detail/3d.jpeg'
    };
}
export default {
    i18next: {
        ns: 'md-detail-info'
    },
    data: function() {
        return {
            visible: false,
            showPop: false,
            imgIndex: 0,
            DEFAULT_IMAGE:
                '//fs01.chime.me/image/fs/sitebuild/2021224/20/original_ddff9285-b8a4-4fd5-840f-0233eb9cc979.png',
            selectedTabIndex: 0,
            source: {
                imgs: [],
                virtuals: [],
                videos: []
            }
        };
    },
    components: {
        BottomMenu,
        Swiper,
        Slide: SwiperSlide
    },
    computed: {
        ...rootMapState(usePageStore, {
            'page': store => store.page || {}
        }),
        ...rootMapState(useUserStore, {
            'user': store => store.user
        }),
        ...mapState({
            'hasFavor': 'hasFavor'
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        tabs() {
            return [
                { name: this.$t('md-detail-info.photos'), value: 'imgs' },
                {
                    name: this.$t('md-detail-info.virtualTour'),
                    value: 'virtuals'
                },
                { name: this.$t('md-detail-info.videoTour'), value: 'videos' }
            ];
        },
        allImgs() {
            return this.source?.imgs?.filter(v => v.type === 'img') || [];
        },
        info() {
            return this.listingDetail.info || {};
        },
        iframeStyle() {
            return 'width: 100%; height: 360px';
        },
        isOffer() {
            return ['broker', 'standard'].includes(this.theme);
        }
    },
    props: {
        onFavoriteClick: {
            type: Function
        },
        sharePop: {
            type: Function
        },
        schedulePop: {
            type: Function
        },
        listingDetail: {
            type: Object,
            required: true
        },
        sold: {
            type: Boolean,
            default: false
        },
        theme: {
            type: String,
            default: 'classic'
        }
    },
    provide() {
        return {
            onFavoriteClick: this.onFavoriteClick,
            theme: this.theme,
            sharePop: this.sharePop,
            schedulePop: this.schedulePop
        };
    },
    created() {
        this.initMediaData();
    },
    beforeMount() {
        this.fingerPs = Promise.all([
            util.addScript(
                '//static.chimeroi.com/servicetool-temp/AlloyFinger.js'
            ),
            util.addScript(
                '//static.chimeroi.com/servicetool-temp/transform.js'
            )
        ]);
    },
    methods: {
        onSwiperInit(swiper) {
            if (this.selectedTabIndex === 0) {
                setTimeout(() => {
                    swiper.slideTo(this.imgIndex)
                })
            }
        },
        slideChange(swiper) {
            if (this.selectedTabIndex === 0) {
                this.imgIndex = swiper.realIndex;
                this.resetAllImg();
            }
        },
        async tabClick(item, index) {
            if (index > 0) {
                // https://www.dropbox.com/s/2lza92tb05edq6p/27th%20HPP%20Final.mov?dl=0
                const url = this.source[item.value]?.[0]?.url;
                if (url) {
                    const res = await API.getCanXFrame.call(this, url);
                    if (!res?.data?.canXFrame) {
                        window.open(url, '_blank');
                        return;
                    }
                }
            }
            this.selectedTabIndex = index;
        },
        /**
         * type
         * photo -> img
         * virtuals -> 3d,virtualTour
         * videos-> video
         */
        initMediaData() {
            let listingPictures = !this.info.listingPictures
                ? []
                : this.info.listingPictures.split('|').filter(item => !!item);
            this.source.imgs = listingPictures.map(url => {
                return {
                    preview: url,
                    type: 'img',
                    url
                };
            });

            let { link, chimeVideoLink } = this.info;
            let virtualLinks = link ? link.trim().split(' ') : [],
                videoLinks = chimeVideoLink
                    ? chimeVideoLink.trim().split(' ')
                    : [];
            const res = [
                getMatterPort(virtualLinks),
                getMatterPort(videoLinks)
            ];
            const bothHasMatterport = res.every(v => !!v);
            const inVirtual = !!res[0];
            const inVideo = !!res[1];
            // matterport Classified as virtual tour  Put it in the picture dripping two
            let matterport = getMatterPort([...virtualLinks, ...videoLinks]);
            if (matterport) {
                const url = matterport.url;
                //  from links kick out matterport
                virtualLinks = virtualLinks.filter(link => link != url);
                if (!bothHasMatterport) {
                    videoLinks = videoLinks.filter(link => link != url);
                }

                if (bothHasMatterport) {
                    matterport.from = 'virtual';
                    this.source.virtuals.push(matterport);
                } else {
                    if (inVirtual) {
                        matterport.from = 'virtual';
                        this.source.virtuals.unshift(matterport);
                    } else if (inVideo) {
                        matterport.from = 'video';
                        this.source.videos.unshift(matterport);
                    }
                }

                // matterport The preview image is placed second
                this.source.imgs =
                    this.source.imgs.length > 2
                        ? [
                            ...this.source.imgs.slice(0, 1),
                            matterport,
                            ...this.source.imgs.slice(1)
                        ]
                        : [...this.source.imgs, matterport];
            }

            // virtual tour remove matterport Everything except is placed after the image stream preview
            let placeImageIndex = 0;
            if (virtualLinks.length > 0) {
                const virtuals = virtualLinks.map(v => {
                    return {
                        preview:
                            listingPictures[placeImageIndex++] ||
                            this.DEFAULT_IMAGE,
                        type: 'virtualTour',
                        url: v
                    };
                });
                this.source.virtuals.push(...virtuals);
                this.source.imgs.push(...virtuals);
            }

            // video  put at the end of the picture stream
            if (videoLinks.length > 0) {
                this.source.videos = videoLinks.map((url, index) => {
                    return {
                        preview:
                            listingPictures[placeImageIndex++] ||
                            this.DEFAULT_IMAGE,
                        type: 'video',
                        url
                    };
                });

                this.source.imgs.push(...this.source.videos);
            }

            if (this.source.imgs.length === 0) {
                this.source.imgs.push({
                    preview: this.DEFAULT_IMAGE,
                    type: 'img'
                });
            }
        },
        showCurrentTab(tab) {
            return tab.type === 'imgs'
                ? this.allImgs.length
                : this.source[tab.value].length;
        },
        async streamToInner(item, index) {
            const { type, url } = item;
            // const url = `https://www.dropbox.com/s/2lza92tb05edq6p/27th%20HPP%20Final.mov?dl=0`;
            if (url && type && type !== 'img') {
                const res = await API.getCanXFrame.call(this, url);
                if (!res?.data?.canXFrame) {
                    window.open(url, '_blank');
                    return;
                }
            }
            if (type == 'img') {
                this.showInner(type, index);
            } else {
                let i, source;
                if (item?.from) {
                    source = item.from + 's';
                } else {
                    if (type === 'video') {
                        source = this.source.videos;
                    } else if (type === 'virtual') {
                        source = this.source.virtuals;
                    }
                }
                i =
                    Array.isArray(source) &&
                    source.findIndex(v => v.url === url);
                i == -1 && (i = 0);
                this.showInner(type, i, item?.from);
            }
        },
        showInner(type, index, from = undefined) {
            if (type === 'img') {
                let count = this.source.imgs
                    .slice(0, index)
                    .filter(v => v.type != 'img').length;
                index = index - count;
                console.log('showInner======', index);
                this.imgIndex = index;
                this.showPop = true;
                this.selectedTabIndex = 0;
                setTimeout(() => {
                    this.bindPinchEvent();
                });
            } else {
                this.showPop = true;
                if (['3d', 'virtualTour'].includes(type)) {
                    // virtualTour
                    if (from && from === 'video') {
                        // video
                        this.selectedTabIndex = 2;
                    } else {
                        this.selectedTabIndex = 1;
                    }
                } else {
                    // video
                    this.selectedTabIndex = 2;
                }
            }
        },
        handleShare() {
            this?.sharePop();
        },
        formatUrl(url) {
            const res = this.parseYoutube(url);
            if (res.overwrite) {
                return res.url;
            } else {
                return url;
            }
        },
        parseYoutube(url) {
            /*https://youtu.be/Ounzu9U8NNc
            https://youtu.be/Ounzu9U8NNc?t=19
            https://www.youtube.com/watch?v=Ounzu9U8NNc
             converted to https://www.youtube.com/embed/Ounzu9U8NNc
            */
            let hash;
            try {
                let regs = [
                    /http?s:\/\/youtu.be\/([^?/]*)/,
                    /http?s:\/\/www.youtube.com\/watch\?v=([^?/]*)/
                ];

                let matches = regs.map(reg => url.match(reg));
                matches = matches.filter(match => match?.length === 2);
                hash = matches[0][1] || '';
            } catch (error) {
                return { overwrite: false, url };
            }

            if (!hash) {
                return { overwrite: false, url }; 
            }
            return {
                overwrite: true,
                url: `https://www.youtube.com/embed/${hash}`
            };
        },

        canPlayWithVideo(url) {
            return /^.*.mp4|.webm|.ogg$/i.test(url);
        },
        _openMediaPop(index = 0) {
            this.visible = true;
            this.$nextTick(() => {
                const mediaPop = this.$refs?.mediaPop;
                const el =
                    mediaPop && mediaPop.querySelectorAll('.img-box')[index];
                index &&
                    el &&
                    el.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'start'
                    });
            });
        },
        _openVirtualTourPop(index = 0) {
            this.visible = true;
            this.fingerPs.then(() => {
                this.showInner('virtualTour', index);
            });
        },
        _openVideoPop(index = 0) {
            this.visible = true;
            this.fingerPs.then(() => {
                this.showInner('video', index);
            });
        },
        _openImgPop(index = 0) {
            this.visible = true;
            this.fingerPs.then(() => {
                this.showInner('img', index);
            });
        },
        _getSource() {
            return util.deepClone(this.source);
        },
        closeInnerPop() {
            this.showPop = false;
        },
        bindPinchEvent() {
            let imgs = this.$refs?.siteImg;
            this.fingerPs.then(() => {
                const AlloyFinger = window?.AlloyFinger;
                imgs.length &&
                    Array.from(imgs).map(img => {
                        img = img.$el;
                        window?.Transform(img);
                        img.setAttribute(
                            'data-inittransform',
                            img.style.transform
                        );
                        let initScale = 1;
                        new AlloyFinger(img, {
                            // pressMove: function (evt) {
                            //     if (img.scaleX == 1) return;
                            //     img.translateX += evt.deltaX;
                            //     img.translateY += evt.deltaY;
                            //     evt.preventDefault();
                            // },
                            multipointStart: function() {
                                initScale = img.scaleX;
                            },
                            pinch: function(evt) {
                                const scale = initScale * evt.zoom;
                                img.scaleX = img.scaleY = scale < 1 ? 1 : scale;
                            }
                        });
                    });
            });
        },
        resetAllImg() {
            let imgs = this.$refs?.siteImg;
            imgs?.length &&
                Array.from(imgs).map(img => {
                    img = img.$el;
                    img.style.transform =
                        img.getAttribute('data-inittransform');
                });
        },
        getElScale(el) {
            return +el.style?.transform?.match(/scale\((.*)\)/)[1] || 1.0;
        },
        removePinchEvent() {
            const Hammer = window?.Hammer;
            Hammer && Hammer.Manager.destroy();
        },
        close() {
            this.visible = false;
        }
    },
    watch: {
        visible: function(newval) {
            if (!newval) {
                this.display &&  this.display(false)
            } 
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
@import '@/theme/media.scss';
.comp-media-pop {
    position: fixed;
    z-index: var(--level-subhigh);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    overflow: hidden;
    .iconfont {
        cursor: pointer;
        &.icon-heart-fill {
            &.active {
                color: #f0454c !important;
            }
        }
    }
    .comp-media-pop_outer {
        height: 100%;

        .comp-media-pop_header {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 1;
            background: linear-gradient(
                to bottom,
                rgba(0, 0, 0, 0.4),
                rgba(0, 0, 0, 0)
            );
            .iconfont {
                padding: 20px;
            }
            .wrap {
                height: 100%;
                display: flex;
                justify-content: space-between;
                .operator {
                    display: flex;
                    align-items: center;
                    .iconfont {
                        padding: 20px 10px;
                        font-size: 16px;
                    }
                }
                .iconfont {
                    font-size: 14px;
                    color: #fff;
                    &.icon-heart,
                    &.icon-heart-fill {
                        margin-right: 10px;
                    }
                }
            }
        }
        .comp-media-pop_content {
            width: 100%;
            height: 100%;
            overflow-y: auto;
            &::-webkit-scrollbar {
                width: 0;
                height: 0;
            }
            .img-box {
                width: 100%;
                height: 40%;
                margin-bottom: 5px;
                .loading-box {
                    background-color: transparent;
                }
                &:last-child {
                    margin-bottom: 0;
                }
                img {
                    object-fit: cover;
                }
            }
            .video-preview {
                margin-bottom: 5px;
            }
        }
    }
    .com-media-pop_inner {
        height: 100%;
        width: 100%;
        background: #191919;
        display: flex;
        flex-direction: column;
        position: relative;
        .inner-tab {
            display: flex;
            padding: 6px 15px 0px;
            border-bottom: 1px solid #363636;
            p {
                padding: 10px 15px;
                color: #fff;
                cursor: pointer;
                &.active {
                    color: var(--color-theme);
                    border-bottom: 2px solid var(--color-theme);
                }
            }
        }
        .inner-status {
            padding: 20px 15px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            position: absolute;
            top: 40px;
            z-index: 1;
            width: 100%;
            p {
                flex: 1;
                color: #fff;
                text-align: center;
            }
            .iconfont {
                color: #fff;
                &.icon-close-light {
                    font-size: 12px;
                }
                &.active {
                    color: var(--color-theme);
                }
            }
        }
        .inner-content {
            flex: 1;
            display: flex;
            padding: 58px 0;
            flex-direction: column;
            justify-content: center;
            position: relative;
            z-index: 0;
            .swiper-container {
                width: 100%;
                height: 100%;
                overflow: hidden;
                img {
                    width: 100%;
                    transition: 0.3 all ease;
                }
                .video-content {
                    width: 100%;
                    video {
                        width: 100%;
                        height: 100%;
                    }
                }
                .slide-content {
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }
            }
        }
    }
    .video-preview {
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        img {
            width: 100%;
            max-height: 40%;
            object-fit: cover;
            filter: brightness(0.9) blur(2px);
        }
        .play-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 67px;
            height: 67px;
            border-radius: 50%;
            background: #fff;
            text-align: center;
            line-height: 67px;
            .iconfont {
                font-size: 24px;
                transform: rotate(-90deg);
                display: inline-block;
                margin-left: 4px;
            }
        }
    }
    .swiper {
        width: 100%;
        height: 100%;
        .swiper-slide {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        img {
            width: 100%;
        }
    }
}
</style>
